import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarInsurance from "./component";
import {getCheckoutInsuranceCMSConfig } from "../../checkout-info/actions";
import { getInsuranceDetails, submitInsuranceDetails } from "../../add-ons/actions";
import { updatePostBcStep } from "../../add-ons/actions";

const mapStateToProps = ({
    carDetails: {
        content: {
            appointmentId
        }

    },
    checkout: {
        order: {
            orderId,
            financeProvider
        },
        cmsConfig
    },
    addOns: {
        insuranceDetails
    } = {}
}) => ({
    appointmentId,
    orderId,
    cmsConfig,
    financeProvider,
    insuranceDetails
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getInsuranceCmsConfigConnect: getCheckoutInsuranceCMSConfig,
    getInsuranceDetailsConnect: getInsuranceDetails,
    submitInsuranceDetailsConnect: submitInsuranceDetails,
    updatePostBcStepConnect: updatePostBcStep
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarInsurance);
